/*
Ravi 04/24/2023 2698964415 Added popup in dynamic field name
Sohel 05/22/2023 2698964415 Added Imports and Exports in Schedular
Prakash 22/05/2023 2698964415 fixed inputfield in alignments.
Akhila 06/20/2023 2698964415 bug fix implemented line waise values
Ravi 06/15/2023 2698964415 added show label and placeholder conditionally
Akhila 30/06/2023 2698964415 condtionaly label name change for folder path and file name
*/
import {Button, TextField} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useRef} from 'react';
import {useContext} from 'react';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import AddRuleSelectField from '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/AddRuleSelectField';
import '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/styles.scss';


const AddFileName = ({
  handleClose,
  setFieldValues,
  addValues,
  imports = false,
  isScheduler,
  workqueue,
  moduleType,
  DmModuleType,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const fieldNameTypeOptions = [
    {key: 'Date', value: 'Date - {YYYYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYYYY}'},
    {key: 'Date', value: 'Date - {YYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYY}'},
    {key: 'Date', value: 'Date - {YYMM}'},
    {key: 'Date', value: 'Date - {MMYY}'},
    {key: 'DateTime', value: 'Date Time - {MMDDYYYYHHmmSS}'},
    {key: 'ReportCode', value: 'Name - {Name}'},
    {key: 'DateTime', value: 'Executed By - {EXECUTED_BY}'},
  ];
  const ImportsFieldNameTypeOptions = [
    {key: 'Date', value: 'Date - {YYYYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYYYY}'},
    {key: 'Date', value: 'Date - {YYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYY}'},
    {key: 'Date', value: 'Date - {YYMM}'},
    {key: 'Date', value: 'Date - {MMYY}'},
    {key: 'DateTime', value: 'Date Time - {MMDDYYYYHHmmSS}'},
    {key: 'ImportManagerCode', value: 'Name - {Name}'},
    {key: 'DateTime', value: 'Executed By - {EXECUTED_BY}'},
  ];
  const expressionRef = useRef();
  const placeholderName =
    isScheduler && moduleType ? moduleType : DmModuleType ? DmModuleType : workqueue ? 'Work Queue' : 'Report';
  const initialValues = {
    fields: null,
    expression: addValues?.outputFileName ?
      addValues?.outputFileName :
      addValues?.outputFileNameReport ?
        addValues?.outputFileNameReport :
        ' ',
  };

  const handleSubmit = (values) => {
    if (isScheduler) {
      setFieldValues('outputFileNameReport', values?.expression);
    } else {
      setFieldValues('outputFileName', values?.expression);
    }
    handleClose();
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
      {(props) => {
        const {
          values,
          handleChange,
          setFieldValue,
          resetForm,
        } = props;
        return (
          <Form>
            <div className="col-12">
              <div className="row">
                <AddRuleSelectField
                  label={'File Name'}
                  options={imports ? ImportsFieldNameTypeOptions : fieldNameTypeOptions}
                  optionLable={(option) => (option && option?.value ? option?.value : '')}
                  name="fields"
                  placeholder="Select File Name"
                  value={values.fields}
                  handleChange={(_, value) => {
                    setFieldValue('fields', value);
                  }}
                  handleInsert={() => {
                    const selectedFunc = values?.fields?.value?.split('-')[1];
                    console.log(selectedFunc, 'selectedFunc') ?
                      `${values?.fields?.value?.split('-')[1]}` :
                      '';
                    const cursorPosition = expressionRef.current.selectionStart;
                    console.log(cursorPosition, 'cursorPosition');
                    if (values.expression) {
                      // setFieldValue(
                      //   "expression",
                      //   values.expression?.slice(0, cursorPosition) +
                      //     selectedFunc +
                      //     values.expression.slice(cursorPosition)
                      // );
                      setFieldValue(
                        'expression',
                        values.expression?.slice(0) + selectedFunc,
                        // +
                        //   values.expression.slice(selectedFunc?.length)
                      );
                      expressionRef.current.focus();
                    } else {
                      setFieldValue('expression', selectedFunc);
                    }
                  }}
                />
              </div>

              <div className="row my-3 new-standard-textfields reportout-filed">
                <div className="col-md-5 col-lg-4 col-xl-3 form-group">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${placeholderName} Output File Name`}
                    className={` ${classes.labelName}`}
                    label={`${placeholderName} Output File Name`}
                    multiline
                    minRows={2}
                    maxRows={2}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="expression"
                    value={values.expression}
                    onChange={(e) => {
                      //   setExpression(e?.target?.value);
                      handleChange(e);
                    }}
                    //  onBlur={handleBlur}
                    inputRef={expressionRef}
                    fullWidth
                    // touched={touched.expression}
                    // error={Boolean(touched.expression && errors.expression)}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center new-standard-textfields mb-3">
                <Button
                  variant="outlined"
                  onClick={() => {
                    resetForm(initialValues);
                    // setErrorMessage(null);
                    // setSuccessMessage(null);
                  }}
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>

                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot} `}
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddFileName;
